<template>
        <div class="warp" ref="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'用户管理'},{name:'用户列表'}]" :title="'用户列表'"  ref="breadcrumb"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">用户类型：</span>
                        <el-select v-model="sendInfo.userType" placeholder="请选择" size="small" clearable style="width:100px;">
                            <el-option
                                    v-for="item in userTypeList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">客户经理：</span>
                        <el-select v-model="sendInfo.bind" placeholder="请选择" size="small" clearable style="width:100px;">
                            <el-option
                                    v-for="item in customerManagerList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">账号状态：</span>
                        <el-select v-model="sendInfo.status" placeholder="请选择" size="small" clearable style="width:100px;">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">账号来源：</span>
                        <el-select v-model="sendInfo.source" placeholder="请选择" size="small" clearable style="width:100px;">
                            <el-option
                                    v-for="item in sourceList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">创建日期：</span>
                        <el-date-picker style="width:250px;"
                                size="small"
                                v-model="dateS"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                :default-time="['24:00:00','23:59:59']"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索：</span>
                        <el-select v-model="getSelect" size="small" clearable style="width:100px;">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable style="width:150px;"></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="handleReset" class="retrievalBtn">重置</el-button></el-button>
                    <!-- <el-button type="primary" size="small" @click="exportFile" class="retrievalBtn" v-if="authorities.indexOf('sys:permission:background:user:statistics:list:button:export')!=-1">导出</el-button> -->
                </div>
                <div class="right">
                  <el-button type="primary" size="small" @click="add" icon="el-icon-plus" class="retrievalBtn" v-if="authorities.indexOf('sys:permission:background:user:list:button:add')!=-1">添加账号
                    </el-button>
                    <el-button size="small" @click="onOenExpert" icon="el-icon-upload" class="retrievalBtn">用户导入
                    </el-button>
                    <el-button size="small" @click="move" class="retrievalBtn" v-if="authorities.indexOf('sys:permission:background:user:list:button:hand:over')!=-1">
                        移交客户经理
                    </el-button>
                  </div>
            </div>
            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    v-loading="loading"
                element-loading-text="请求中......"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    @sort-change="sortChange"
                    @selection-change="handleSelectionChange">
                <el-table-column
                        fixed
                        type="selection"
                        
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="id"
                        show-overflow-tooltip
                        
                        label="账号ID">
                </el-table-column>
                <el-table-column
                        prop="userName"
                        show-overflow-tooltip
                        
                        label="账号">
                </el-table-column>
                <el-table-column
                        width="100px"
                        prop="phone"
                        show-overflow-tooltip
                        
                        label="绑定手机号">
                </el-table-column>

                <el-table-column
                        prop="companyName"
                        show-overflow-tooltip
                        
                        label="公司名称">
                </el-table-column>
                <el-table-column
                        prop="userTypeName"
                        show-overflow-tooltip
                        
                        label="用户类型">
                </el-table-column>
                <!-- <el-table-column
                        prop="sourceName"
                        show-overflow-tooltip
                        
                        label="企业全称">
                </el-table-column> -->
                <el-table-column
                        prop="sourceName"
                        show-overflow-tooltip
                        
                        label="账号来源">
                </el-table-column>
                <el-table-column
                        prop="customerManager"
                        show-overflow-tooltip
                        
                        label="客户经理">
                </el-table-column>
                <el-table-column
                        width="120px"
                        prop="createTime"
                        show-overflow-tooltip
                        
                        sortable="custom"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="statusName"
                        show-overflow-tooltip
                        
                        label="账号状态">
                </el-table-column>
                <el-table-column
                        v-if="authorities.indexOf('sys:permission:background:user:list:button:view')!=-1 ||
                            (authorities.indexOf('sys:permission:background:user:list:button:edit')!=-1) ||
                        authorities.indexOf('sys:permission:background:user:list:button:status')!=-1 ||
                        authorities.indexOf('sys:permission:background:user:list:button:reset:password')!=-1"
                        label="操作"
                        
                        width="300px">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)" v-if="authorities.indexOf('sys:permission:background:user:list:button:view')!=-1">查看
                        </el-button>
                        <el-button   class="super" size="small" type="primary" plain  @click="editoer(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:list:button:edit')!=-1">编辑
                        </el-button>
                        <!-- <el-button :disabled="scope.row.source==0"  class="super" size="small" type="primary" plain  @click="editoer(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:list:button:edit')!=-1">编辑
                        </el-button> -->
                        <el-button size="small" :type="scope.row.statusButtonName === '启用'?'success':'warning'" class="super" plain @click="sold(scope.row)" v-if="authorities.indexOf('sys:permission:background:user:list:button:status')!=-1">
                            {{scope.row.statusButtonName}}
                        </el-button>
                        <el-button class="super" type="primary" plain size="small" @click="resetPW(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:list:button:reset:password')!=-1">重置密码
                        </el-button>
                        <!-- <el-button :disabled="scope.row.source==0"  class="super" type="primary" plain size="small" @click="resetPW(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:list:button:reset:password')!=-1">重置密码
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="sendInfo.currentPage"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="sendInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalPage">
                </el-pagination>
            </div>
            <!-- 弹出层 -->
            <!-- 移交客户经理 -->
            <el-dialog
                    title="移交客户经理"
                    :visible.sync="dialogMove"
                    width="31%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>选择客户经理：</div>
                        <div class="content">
                            <el-select v-model="sendInfoTwo.id" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in customerManagerLists"
                                        :key="item.id"
                                        :label="item.realName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.id']">错误提示：{{errors['sendInfoTwo.id']}}</div>
                    <div class="hint significance">重要提示：重新指派客户经理后，该用户与原客户经理相关的数据都会移交给新的客户经理，请谨慎操作</div>
                    <div class="doubleBtn">
                        <el-button type="primary" size="small" @click="submit(1)">确认</el-button>
                        <el-button  @click="cancel" size="small">取消</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 添加用户 -->
            <el-dialog
                    title="添加账号"
                    :visible.sync="dialogAdd"
                    :before-close="cancel"
                    width="40%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>账号：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.userName" :disabled="edit" @blur="acontRepeat" maxlength="20"
                                      placeholder="6-20位数字,字母和下划线"></el-input>
                            <div class="error" v-if="repet">【该账号已重复】，不可完成新建</div>
                            <div class="error" v-if="errors['acontInfo.userName']">
                                错误提示：{{errors['acontInfo.userName']}}
                            </div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>企业名称：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.companyName" maxlength="20"
                                      placeholder="请输入企业全称"></el-input>
                            <div class="error" v-if="errors['acontInfo.companyName']">
                                错误提示：{{errors['acontInfo.companyName']}}
                            </div>
                        </div>
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>统一社会信用代码：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.companyNum" maxlength="18"
                                      placeholder="请输入统一社会信用代码"></el-input>
                            <div class="error" v-if="errors['acontInfo.companyNum']">
                                错误提示：{{errors['acontInfo.companyNum']}}
                            </div>
                        </div>
                    </div>

                    <div class="child mt10">
                        <div class="name">初始密码：</div>
                        <div class="content">初始密码与账号相同</div>
                    </div>
                    <!-- userTypeList -->
                    <div class="child">
                        <div class="name"><span>*</span>用户类型：</div>
                        <div class="content">
                            <el-radio-group v-model="acontInfo.userType" @change="changeUserType">
                                <div v-if="userTypeAdd.length>0">
                                    <el-radio style="margin-bottom: 10px;" :disabled="edit" :label="item.value"
                                              v-for="(item,index) in userTypeAdd" :key="index">{{item.name}}
                                    </el-radio>
                                </div>
                            </el-radio-group>
                            <div class="error" v-if="errors['acontInfo.userType']">*{{errors['acontInfo.userType']}}
                            </div>
                        </div>
                    </div>
                    <div class="child" v-show="acontInfo.userType">
                        <div class="name"><span>*</span>联系人：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.contact" maxlength="20"></el-input>
                            <div class="error" v-if="errors['acontInfo.contact']">*联系人错误</div>
                        </div>
                    </div>

                    <div class="child" v-show="acontInfo.userType">
                        <div class="name"><span>*</span>联系电话：</div>
                        <div class="content">
                            <el-input v-model="acontInfo.contactPhone" maxlength="11"></el-input>
                            <div class="error" v-if="errors['acontInfo.contactPhone']">*联系电话错误</div>
                        </div>
                    </div>

                    <div class="child"
                         v-show="acontInfo.userType=='CORPORATE_CLIENTS' || acontInfo.userType=='INSTITUTIONAL_INVESTOR'  || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"><span>*</span>{{acontInfo.userType=='INSTITUTIONAL_INVESTOR'?'上传名片':'营业执照'}}：
                        </div>
                        <div class="content">
                            <upLoad
                                    :action="'backstage/annex/file'"
                                    :size="20"
                                    :number="1"
                                    :accept="'image/png,image/jpg'"
                                    v-model="acontInfo.attachmentUrl"/>
                            <div class="error" v-if="errors['acontInfo.attachmentUrl']">
                                *{{errors['acontInfo.attachmentUrl']}}{{acontInfo.userType=='INSTITUTIONAL_INVESTOR'?'名片':'营业执照'}}
                            </div>
                        </div>
                    </div>

                    <div class="child"
                         v-show="acontInfo.userType=='CORPORATE_CLIENTS' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint">*png、jpg等常规格式图片，大小不超过5M</div>
                        </div>
                    </div>

                    <div class="child" v-show="acontInfo.userType=='FINANCE_LEASING_COMPANY'">
                        <div class="name"><span>*</span>分类:</div>
                        <div class="content">
                            <el-select v-model="acontInfo.classify" placeholder="请选择">
                                <el-option
                                        v-for="(item,index) in classifyList"
                                        :key="index"
                                        :label="item.dictName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <div class="error" v-if="errors['acontInfo.classify']">*{{errors['acontInfo.classify']}}
                            </div>
                        </div>
                    </div>
                    <div class="child"
                         v-show="acontInfo.userType=='BANK' || acontInfo.userType=='GUARANTEE_COMPANY' || acontInfo.userType=='FINANCE_LEASING_COMPANY'">
                        <div class="name"><span>*</span>LOGO:</div>
                        <div class="content">
                            <upLoad
                                    :action="'backstage/annex/file'"
                                    :size="20"
                                    :number="1"
                                    :accept="'image/png,image/jpg'"
                                    v-model="acontInfo.logoUrl"/>
                            <div class="error" v-if="errors['acontInfo.logoUrl']">*{{errors['acontInfo.logoUrl']}}</div>
                        </div>
                    </div>
                    <div class="child"
                         v-show="acontInfo.userType=='INSTITUTIONAL_INVESTOR' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='BANK' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"></div>
                        <div class="content">
                            <div class="hint">*png、jpg等常规格式图片，大小不超过1M</div>
                        </div>
                    </div>

                    <div class="child" v-show="acontInfo.userType=='BANK'">
                        <div class="name"><span>*</span>银行名称（简称）:</div>
                        <div class="content">
                            <el-input v-model="acontInfo.abbreviation"></el-input>
                            <div class="error" v-if="errors['acontInfo.abbreviation']">
                                *{{errors['acontInfo.abbreviation']}}
                            </div>
                        </div>
                    </div>

                    <div class="child" v-show="acontInfo.userType=='BANK'">
                        <div class="name"><span>*</span>官网链接:</div>
                        <div class="content">
                            <el-input v-model="acontInfo.websiteLink"></el-input>
                            <div class="error" v-if="errors['acontInfo.websiteLink']">
                                *{{errors['acontInfo.websiteLink']}}
                            </div>
                        </div>
                    </div>

                    <div class="child"
                         v-show="acontInfo.userType=='BANK' || acontInfo.userType=='FINANCE_LEASING_COMPANY' || acontInfo.userType=='GUARANTEE_COMPANY'">
                        <div class="name"><span>*</span>{{acontInfo.userType=='BANK'?'银行简介':'公司简介'}}:</div>
                        <div class="content remark">
                            <el-input style="width: 300px;min-height: 120px;" type="textarea" :rows="2"
                                      v-model="acontInfo.remarks" show-word-limit maxlength="500"></el-input>
                            <div class="error" v-if="errors['acontInfo.remarks']">*{{errors['acontInfo.remarks']}}</div>
                        </div>
                    </div>

                    <div class="hint">说明：新添加的账号为个人客户类型，需在用户前端提交资料完成认证，相关的业务也需在用户前端完成</div>
                    <div class="doubleBtn">
                        <el-button size="small" @click="cancel">取消</el-button>
                        <el-button type="primary" size="small" @click="submitAdd()">确认</el-button>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
              title="用户导入"
              :visible.sync="dialogExpVisible"
              width="50%">
              <el-form ref="ruleForm" :model="editForm" :rules="rules" label-width="150px" size="mini" class="detail" label-suffix="：">
        <el-steps v-if="active < 3" :active="active" align-center>
          <el-step title="上传文件" icon="el-icon-dot" />
          <el-step title="数据预览" icon="el-icon-dot" />
          <el-step title="导入数据" icon="el-icon-dot" />
          <el-step title="导入完成" icon="el-icon-dot" />
        </el-steps>
        <!-- 步骤一 -->
        <div v-if="active === 1" calss="step">
          <template v-if="!errorList.active">
            
            <el-descriptions title="" :column="1" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-download" />
                </template>
                <div class="step_title">填写导入数据信息</div>
                <div class="step_desc">请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除</div>
                <el-button @click="openInner"  type="text">下载模板</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="mt20" title="" :column="1" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-upload2" />
                </template>
                <div class="step_title">上传填好的信息表</div>
                <div class="step_desc">文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据</div>
                <el-button type="text" @click="onUpload">上传文件</el-button>
                <!-- <el-upload ref="upload" action accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :limit="1" :before-upload="handleBeforeUpload" :show-file-list="false" :http-request="uploadSectionFile">
                  <el-button type="text" :loading="uploading">上传文件</el-button>
                </el-upload> -->
              </el-descriptions-item>
            </el-descriptions>
            
          </template>
          <div v-else class="step_error" style="margin-top:20px">
            <el-descriptions title="" :column="1" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-set-up" />
                </template>
                <div class="step_error_title">正常数量条数：<span>{{ uploadData.passCount || 0 }}条</span></div>
                <div class="step_error_title" style="margin-top:5px">异常数量条数：<span class="red">{{ uploadData.errorCount || 0 }}条</span></div>
              </el-descriptions-item>
            </el-descriptions>
            <div class="mt20 step_error_lists">
              <div class="step_error_lists_title">异常提示：</div>
              <template v-if="uploadData.errorTipsList && uploadData.errorTipsList.lengeth !== 0">
                <div v-for="(item,idx) in uploadData.errorTipsList" :key="idx" class="step_error_lists_item">{{ item }}</div>
              </template>
              <div v-else class="no_data">暂无异常信息</div>
            </div>
          </div>
        </div>
        <div v-else-if="active === 2" class="step mt20">
        
          <el-table :data="uploadData.passUserList" style="width: 100%" height="300px" :header-cell-style="headerStyle">
              <el-table-column label="账号" prop="userName" show-overflow-tooltip />
              <el-table-column label="企业名称" prop="companyName" show-overflow-tooltip />
              <el-table-column label="统一社会信用代码" prop="companyNum" show-overflow-tooltip />
              <el-table-column label="联系人" prop="contact" show-overflow-tooltip />
              <el-table-column label="联系电话" prop="contactPhone" show-overflow-tooltip />
          </el-table>
        </div>
        <div v-else-if="active === 3" class="step_percentage">
          <el-progress :percentage="percent" :stroke-width="12" />
          <div class="step_percentage_tip">数据正在导入</div>
        </div>
        <div v-else class="step_success">
          <i class="el-icon-success" />
          <div class="step_success_title">数据导入完成</div>
          <div class="step_success_info">您已成功导入{{ uploadData.passCount }}条数据</div>
        </div>
      </el-form>

              <span slot="footer" class="dialog-footer">
                  <el-button v-if="active === 2" @click="handleOperate(['prev'])" size="small" class="mr10" type="primary" plain>上一步</el-button>
      <el-button v-if="active === 1 && errorList.active" @click="handleOperate(['upload'])" size="small" type="primary" class="mr10" plain style="margin-right:10px">重新上传</el-button>
      <el-button v-if="active === 2" @click="handleOperate([1,'sub'])" size="small" type="primary" v-show="!errorList.active">下一步</el-button>
      <el-button  v-if="active === 1 && !errorList.active" @click="handleOperate(['next'])" size="small" type="primary" :disabled="disabled">下一步</el-button>
      <!-- <el-dropdown v-if="active === 1" trigger="click" @command="handleCommand" v-show="!errorList.active">
        <el-button @click="handleOperate(['next'])" size="small" type="primary" :disabled="disabled">下一步</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item  :disabled="disabled" :command="1"> 数据预览</el-dropdown-item>
          <el-dropdown-item  :disabled="disabled" :command="2"> 数据异常</el-dropdown-item>
        </el-dropdown-menu> -->
      </el-dropdown>
              </span>
              <el-dialog
              width="30%"
              title="用户类型"
              :visible.sync="innerVisible"
              append-to-body>
              <el-radio-group v-model="downType" class="super_radio">
                <el-radio :label="item.value" v-for="(item,idx) in userTypeList" :key="idx">{{item.name}}</el-radio>
              </el-radio-group>
              <span slot="footer" class="dialog-footer" style="display:flex;justify-content:flex-end">
                <el-button  size="small" @click="innerVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="onDown" v-if="exType === 1">确 定</el-button>
                <el-upload ref="upload" action accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :limit="1" :before-upload="handleBeforeUpload" :show-file-list="false" :http-request="uploadSectionFile" v-else style="margin-left:10px">
                  <el-button size="small" type="primary" :loading="uploading">确定</el-button>
                </el-upload>
              </span>
            </el-dialog>
            </el-dialog>
        </div>
</template>

<script>
    // import breadcrumb from '../../components/breadcrumb';
    import upLoad from '../../components/upLoad';
    import upLoadFiles from '../../components/upLoadFiles';
    import {objectRestore,downLoadTemplate} from '@/utils/common';
    

    export default {
        components: {
            // breadcrumb, 
            upLoad, upLoadFiles
        },
        data() {
            return {
                dialogExpVisible:false,
                innerVisible:false,
                loading:false,
                authorities:JSON.parse(window.localStorage.getItem('authorities')),
                xym: /[1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}/,
                act: /^[\w]{6,20}$/,
                userTypeList: [],//用户类型数组
                customerManagerList: [],//客户经理数组
                statusList: [],//账号状态数组
                sourceList: [],//账号来源数组
                options: [{
                    value: '2',
                    label: '账号'
                }, {
                    value: '3',
                    label: '姓名'
                }, {
                    value: '4',
                    label: '客户经理'
                }, {
                        value: '5',
                        label: '公司名称'
                    }],//检索下拉条件数组
                getSelect: '',//检索下拉的值
                getValue: null,//检索输入框的值
                dateS: [],//日期
                sendInfo: {
                    currentPage: 1,//页码
                    pageSize: 10,//条数
                    userType: null,//用户类型
                    customerManager: null,//客户经理
                    bind: '',
                    status: null,//账号状态
                    source: null,//账号来源
                    startTime: null,//开始时间
                    endTime: null,//结束时间
                    id: null,//账号id
                    userName: null,//账号
                    realName: null,//姓名
                    property: null,//排序字段
                    direction: null,//排序方式
                    companyName:null,//公司名称
                },//检索提交数据
                exportInfo:{},//导出条件
                tableData: [],//表格数据
                totalPage: null,//总页码
                multipleSelection: [],//表格多选结果数组
                dialogMove: false,//移交客户弹出层
                customerManagerLists: [],//客户经理
                sendInfoTwo: {
                    id: null,//客户经理id
                    ids: [],//移交人id
                },
                dialogAdd: false,//添加账号弹出层
                userName: null,//弹出层账号
                // 添加账号
                classifyList: [],//分类
                userTypeAdd: [],//用户类型添加用
                repet: false,//账号是否重复
                acontInfo: {
                    abbreviation: '',//银行简称
                    attachmentUrl: '',//上传图片地址(营业执照，名片)（图片地址最大长度100）
                    classify: '',//分类
                    companyName: '',//企业全称
                    companyNum: '',//统一社会信用代码 [1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}
                    contact: '',//联系人^[\u4e00-\u9fa5]{0,}$
                    contactPhone: '',//联系电话
                    logoUrl: '',//logo地址
                    remarks: '',//银行简介
                    userName: '',//账号(^[\w]{6,20}$)
                    userType: '',//用户类型
                    websiteLink: '',//官网链接
                },
                edit: false,//是否编辑
                usId: '',//用户id
                bHeight: void 0,
                editForm: {
                id: void 0, // 主键id(不传是新增，传是编辑)
                author: void 0, // 用户表主键id
                columnId: void 0, // 栏目id
                displayFlag: void 0, // 显示标志，0=隐藏 1=显示
                knowledgeBrief: void 0, // 内容简介
                knowledgeContent: void 0, // 内容详情
                knowledgeCreator: void 0, // 创建人
                knowledgeEnclosureIds: [], // 知识库附件主键
                knowledgePictureIds: [], // 知识库图片主键
                knowledgeTitle: void 0, // 内容标题
                knowledgefwbIds: [], // 知识库富文本主键
                readType: void 0, // 阅读权限标志，1=私密 2=部分可见 3=全部
                seeUserIds: void 0, // 部分可见人员ids
                seoKeywordword: void 0, // seo关键字
                seoTitle: void 0, // seo标题
                seoRemark: void 0 // seo描述
              },
              rules: {
                knowledgeTitle: [{ required: true, message: '请填写内容标题' }],
                columnId: [{ required: true, message: '请选择所属分类' }],
                knowledgeCreator: [{ required: true, message: '请选择创建人' }],
                displayFlag: [{ required: true, message: '请选择是否展示' }],
                knowledgePictureIds: [{ required: true, message: '请上传内容图片' }],
                knowledgeBrief: [{ required: true, message: '请填写内容简介' }],
                knowledgeContent: [{ required: true, message: '请填写内容详情' }],
                author: [{ required: true, message: '请选择作者' }],
                readType: [{ required: true, message: '请选择阅读权限' }]
              },
              fileList: [], // 上传附件文件
              fileItems: [], // 上传附件文件回显操作集合
              active: 1, // 当前激活步骤
              filters: {
                pageSize: 10,
                pageNum: 1
              },
              errorList: {
                active: false,
                list: []
              },
              percent: 0, // 导入百分数
              interval: void 0,
              uploading: false,
              uploadData: {
                errorCount: void 0, // 错误条数
                errorTipsList: [], // 错误数据
                passUserList: [], // 成功数据
                passCount: void 0 // 成功数量
              },
              file: void 0,
              downType: void 0,
              exType:1,

            }
        },
        computed: {
            errors() {
                return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
            },
            disabled() {
              const { passCount, errorCount } = this.uploadData
              if (!passCount && !errorCount) return true
              else return false
            },
            downName(){
              let lists = this.userTypeList.filter(item=>item.value === this.downType)
              return lists&& lists.length !== 0?lists[0].name:''
            }
        },
        vuerify: {
            'sendInfoTwo.id': {
                test: function (val) {
                    if (this.multipleSelection.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择用户或客户经理'
            },
            'acontInfo.companyName': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '输入企业全称'
            },
            'acontInfo.companyNum': {
                test: function (val) {
                    if (this.xym.test(val)) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '统一社会信用代码格式不正确'
            },
            'acontInfo.userType': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择用户类型'
            },
            'acontInfo.contact': 'realName',
            'acontInfo.contactPhone': 'phone',
            'acontInfo.attachmentUrl': {
                test: function (val) {
                    if (val.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '上传'
            },
            'acontInfo.contact': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择分类'
            },
            'acontInfo.classify': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择分类'
            },
            'acontInfo.logoUrl': {
                test: function (val) {
                    if (val.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '上传名片或上传LOGO'
            },
            'acontInfo.abbreviation': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: "输入银行名称"
            },
            'acontInfo.websiteLink': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: "输入官网链接"
            },
            'acontInfo.remarks': {
                test: function (val) {
                    if (val) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: "输入简介"
            },
            'acontInfo.userName': {
                test: function (val) {
                    if (this.act.test(val)) {
                        return true;
                    } else {
                        this.repet = false
                        return false;
                    }
                },
                message: "【账号格式错误】,不可完成新建"
            },
        },
        created(){
          this.getDic();
        },
        mounted() {
          const that = this
          that.getData();
          let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
        },
        methods: {
          handleReset(){
               const param = {
                 currentPage: 1,//页码
                    pageSize: 10,//条数
                    userType: null,//用户类型
                    customerManager: null,//客户经理
                    bind: '',
                    status: null,//账号状态
                    source: null,//账号来源
                    startTime: null,//开始时间
                    endTime: null,//结束时间
                    id: null,//账号id
                    userName: null,//账号
                    realName: null,//姓名
                    property: null,//排序字段
                    direction: null,//排序方式
                    companyName:null,//公司名称
               }
              this.sendInfo = Object.assign(this.sendInfo,param)
              this.getSelect = void 0
              this.getValue = void 0
              this.dateS = void 0
              this.getData()
          },
          doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
            //导出
            exportFile: function () {
                this.exportInfo=this.sendInfo;
                delete this.exportInfo.currentPage;
                delete this.exportInfo.pageSize;
                console.log(this.exportInfo);
                this.$axiosz.get('backstage/sysUser/export', {params: this.exportInfo}).then(res => {
                    if (res.code == 200) {
                        var aLink = document.createElement('a');
                        var blob = this.dataURLtoBlob(res.data.bytes);
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);   // 转换为base64，可以直接放入a标签href
                        reader.onload = function (e) {
                            var a = document.createElement('a');   // 转换完成，创建一个a标签用于下载
                            a.download = res.data.fileName;
                            a.href = e.target.result;
                            document.body.appendChild(a);    // 修复firefox中无法触发click
                            a.click();
                            document.body.removeChild(a);
                        }
                    } else {
                        this.$alert(res.msg)
                    }
                })
            },
            dataURLtoBlob: function (dataurl) {
                let bstr = atob(dataurl),//负责解码已经使用base64编码了的字符串
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: 'application/vnd.ms-excel;charset=UTF-8;'});
            },
            //用户类型切换 重置数据
            changeUserType: function () {
                this.acontInfo.attachmentUrl = '';//营业执照
                this.acontInfo.classify = '';//分类
                this.acontInfo.logoUrl = '';//logo地址=
                this.acontInfo.contact = '';//联系人
                this.acontInfo.contactPhone = '';//联系电话
                this.acontInfo.abbreviation = '';//银行简称
                this.acontInfo.websiteLink = '';//官网链接
                this.acontInfo.remarks = '';//银行简介
            },
            // 编辑回显
            editoer(row) {
                // this.usId = row.id;
                // this.edit = true;
                // this.$axiosz.get('/backstage/sysUser/manage/edit/' + row.id).then((r) => {
                //     if (r.code == 200) {
                //         this.$vuerify.clear();
                //         let data = r.data;
                //         let acontInfo = {
                //             abbreviation: data.abbreviation,//银行简称
                //             attachmentUrl: data.attachmentUrl,//上传图片地址(营业执照，名片)（图片地址最大长度100）
                //             classify: data.classify,//分类
                //             companyName: data.companyName,//企业全称
                //             companyNum: data.companyNum,//统一社会信用代码 [1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}
                //             contact: data.contact,//联系人^[\u4e00-\u9fa5]{0,}$
                //             contactPhone: data.contactPhone,//联系电话
                //             logoUrl: data.logoUrl,//logo地址
                //             remarks: data.remarks,//银行简介
                //             userName: data.userName,//账号(^[\w]{4,20}$)
                //             userType: data.userType,//用户类型
                //             websiteLink: data.websiteLink,//官网链接
                //         }
                //         this.acontInfo = acontInfo
                //         this.dialogAdd = true;
                //     } else {
                //         this.$alert(r.msg)
                //     }
                // })
                this.$router.push({path: `/userManagement/edit/${row.id}`, query: { index: '/userManagement'},param:{id: row.id,}})
            },
            //保存
            submitAdd: function () {
                const that = this
                that.$vuerify.clear();
                switch (that.acontInfo.userType) {
                    case null || '':
                        that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType'])
                        break;
                    case 'CONSUMER_CLIENT': //个人客户
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'CORPORATE_CLIENTS': //企业客户
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl'])) {
                            that.submitData();
                        }
                        break;
                    case 'INSTITUTIONAL_INVESTOR': //投资机构/个人
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl'])) {
                            that.submitData();
                        }
                        break;
                    case 'BANK': //银行
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.logoUrl', 'acontInfo.abbreviation', 'acontInfo.websiteLink', 'acontInfo.remarks'])) {
                            that.submitData();
                        }
                        break;
                    case 'GOVERNMENT_DEPARTMENT': //政府部门
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'INCUBATOR': //孵化器
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone'])) {
                            that.submitData();
                        }
                        break;
                    case 'FINANCE_LEASING_COMPANY': //融资租赁公司
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl', 'acontInfo.classify', 'acontInfo.logoUrl', 'acontInfo.remarks'])) {
                            that.submitData();
                        }
                        break;
                    case 'GUARANTEE_COMPANY': //担保公司
                        if (that.$vuerify.check(['acontInfo.userName', 'acontInfo.companyName', 'acontInfo.companyName', 'acontInfo.companyNum', 'acontInfo.userType', 'acontInfo.contact', 'acontInfo.contactPhone', 'acontInfo.attachmentUrl', 'acontInfo.logoUrl', 'acontInfo.remarks'])) {
                            that.submitData();
                        }
                        break;
                }
            },
            // 添加账号
            async submitData() {
              const that = this
              try{
                if (!that.edit) {
                    const r = await that.$axiosz.post('/backstage/sysUser/manage', that.$qs.stringify(that.acontInfo))
                    if (r.code == 200) {
                            that.$message({
                                type: 'success',
                                message: '添加账号成功!'
                            });
                            that.getData();
                            that.cancel();
							              that.clearDell();//重置数据
                        } else {
                            that.$alert(r.msg)
                        }
                } else {
                  const res = await that.$axiosz.put('/backstage/sysUser/manage/' + that.usId, that.$qs.stringify(that.acontInfo))
                  if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '编辑账号成功!'
                            });
                            that.getData();
                            that.cancel();
                        } else {
                            that.$alert(r.msg)
                        }
                }
              }catch(e){
                that.$alert(e.msg || (!that.edit?'添加账号成功':'编辑账号成功'))
              }

            },
            // 账号查重
            acontRepeat() {
                if (this.acontInfo.userName == ''||!this.act.test(this.acontInfo.userName)) {
                    return
                }
                this.$axiosz.get('/backstage/sysUser/manage/userName/' + this.acontInfo.userName).then((r) => {
                    if (r.code == 200) {
                        this.repet = false;
                    } else {
                        this.repet = true;
                        this.$alert(r.msg)
                    }
                })
            },
			clearDell(){
				let	acontInfo = {
				    abbreviation: '',//银行简称
				    attachmentUrl: '',//上传图片地址(营业执照，名片)（图片地址最大长度100）
				    classify: '',//分类
				    companyName: '',//企业全称
				    companyNum: '',//统一社会信用代码 [1-9A-GY]{1}[1239]{1}[0-9]{1}[0-9]{5}[0-9A-Z]{10}
				    contact: '',//联系人^[\u4e00-\u9fa5]{0,}$
				    contactPhone: '',//联系电话
				    logoUrl: '',//logo地址
				    remarks: '',//银行简介
				    userName:'',//账号(^[\w]{4,20}$)
				    userType: '',//用户类型
				    websiteLink: '',//官网链接
				}
				this.acontInfo=acontInfo;
				 this.$vuerify.clear();
			},
            //分页功能模块
            //切换每页显示条数
            handleSizeChange(val) {
                this.sendInfo.pageSize = val;
                this.getData();
            },
            //切换页码
            handleCurrentChange(val) {
                this.sendInfo.currentPage = val;
                this.getData();
            },
            //表格选择事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //表格排序事件
            sortChange: function ({column, prop, order}) {
                if (order == 'ascending') {
                    order = 'asc';
                } else {
                    order = 'desc';
                }
                this.sendInfo.property = prop;
                this.sendInfo.direction = order;
                this.getData();
            },
            //表格查看事件
            check: function (row) {
                this.$router.push({path: '/userManagement/detail', query: {id: row.id, index: '/userManagement'}})
            },
            //表格启/禁用事件
            sold: function (row) {
                let str = '';
                if (row.statusButtonName == '启用') {
                    str = '启用后，该账号下所有发布的资讯、产品、项目等需手动上架，确认是否启用？'
                } else {
                    str = '禁用后，该账号下所有发布的资讯、产品、项目等都将自动下架，确认是否禁用？'
                }
                this.$confirm(str, row.statusButtonName, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axiosz.put('backstage/sysUser/manage/status/' + row.id).then((r) => {
                        if (r.code == 200) {
                            this.$message({
                                type: 'success',
                                message: row.statusButtonName + '成功!'
                            });
                            this.getData();
                        } else {
                            this.$alert(r.msg)
                        }
                    })
                }).catch(() => {
                });
            },
            //表格重置密码
            resetPW: function (row) {
                const that = this
                that.$confirm('确认重置该账号密码与账号相同？', '重置密码', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.$axiosz.put('backstage/sysUser/manage/password/' + row.id).then((r) => {
                        if (r.code == 200) {
                            that.$message({
                                type: 'success',
                                message: '重置成功!'
                            });
                            that.getData();
                        } else {
                            that.$alert(r.msg)
                        }
                    })
                }).catch(() => {
                });
            },
            // 弹出层
            //移交客户经理
            move: function () {
                this.dialogMove = true;
                this.$vuerify.clear();
                // const multipleSelection = this.multipleSelection.length !== 0?this.multipleSelection.map(item=>item.id): void 0
                // this.$router.push({path: `/userManagement/move`, query: {index: '/userManagement',multipleSelection}})
            },
            //添加账号
            add: function () {
                // this.dialogAdd = true;
                // this.$vuerify.clear();
                this.$router.push({path: `/userManagement/add`, query: {index: '/userManagement'}})
            },
            //取消按钮
            cancel: function (type) {
                this.dialogMove = false;
                this.manager = null;
                this.sendInfoTwo.id = null;
                this.dialogAdd = false;
                this.userName = null;
            },
            //确定按钮
            submit: function (type) {
                this.$vuerify.clear();
                if (type == 1) { //移交客户
                    let ary = ['sendInfoTwo.id'];
                    let formData = new FormData();
                    for (let item of this.multipleSelection) {
                        formData.append("ids", item.id);
                    }
                    if (this.$vuerify.check(ary)) {
                        this.$axiosz.put('backstage/sysUser/manage/customerManager/' + this.sendInfoTwo.id, formData).then((r) => {
                            if (r.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '移交客户成功!'
                                });
                                this.getData();
                                this.cancel();
                                this.dialogMove = false
                            } else {
                                this.$alert(r.msg)
                            }
                        })
                    }
                } else { //添加账号
                    let arys = ['userName'];
                    if (this.$vuerify.check(arys)) {
                        // this.$axiosz.get('backstage/sysUser/manage/userName/'+this.userName).then((r)=>{
                        //     if(r.code==200){
                        //         this.$axiosz.post('backstage/sysUser/manage/'+this.userName).then((r)=>{
                        //             if(r.code==200){
                        //                 this.$message({
                        //                 type: 'success',
                        //                 message: '添加账号成功!'
                        //             });
                        //             this.getData();
                        //             this.cancel();
                        //             }else{
                        //                 this.$alert(r.msg)
                        //             }
                        //         })
                        //     }else{
                        //         this.$alert(r.msg)
                        //     }
                        // })
                    }
                }
            },
            //设置时间
            setTime: function (date) {
                var now = new Date(date);
                var year = now.getFullYear();       //年
                var month = now.getMonth() + 1;     //月
                var day = now.getDate();            //日
                var hh = now.getHours();            //时
                var mm = now.getMinutes();          //分
                var ss = now.getSeconds();           //秒
                var clock = year + "-";
                if (month < 10)
                    clock += "0";
                clock += month + "-";
                if (day < 10)
                    clock += "0";
                clock += day + " ";
                if (hh < 10)
                    clock += "0";
                clock += hh + ":";
                if (mm < 10) clock += '0';
                clock += mm + ":";
                if (ss < 10) clock += '0';
                clock += ss;
                return (clock);
            },
            //获取字典
            async getDic() {
                // 分类
                const classifyList = await  this.$axiosz.get('rpc/sysDict/parentId//1069409808416768')
                if(classifyList.code === 200) this.classifyList = classifyList.data || [];
                
                const statusList = await this.$axiosz.get('backstage/sysDict/STATUS')
                if(statusList.code === 200) this.statusList = statusList.data || [];

                const userTypeList = await this.$axiosz.get('backstage/sysDict/CUSTOMER_TYPE')
                if(userTypeList.code === 200) this.userTypeList = userTypeList.data || [];

                const userTypeAdd = await this.$axiosz.get('backstage/sysDict/isShow/CUSTOMER_TYPE')
                if(userTypeAdd.code === 200) this.userTypeAdd = userTypeAdd.data || [];

                const customerManagerList = await this.$axiosz.get('backstage/sysDict/BINDING')
                if(customerManagerList.code === 200) this.customerManagerList = customerManagerList.data || [];
                
                const sourceList = await this.$axiosz.get('backstage/sysDict/SOURCE_ACCOUNT')
                if(sourceList.code === 200) this.sourceList = sourceList.data || [];
                
                const customerManagerLists = await this.$axiosz.get('backstage/sysUser/manage/customerManager')
                if(customerManagerLists.code === 200) this.customerManagerLists = customerManagerLists.data || [];

                
            },
            //获取数据
            getData() {
                const that= this
                that.loading = true
                if (that.dateS && that.dateS.length > 0) {
                    that.sendInfo.startTime = that.dateS[0];
                    that.sendInfo.endTime = that.dateS[1];
                } else {
                    that.sendInfo.startTime = null;
                    that.sendInfo.endTime = null;
                }
                that.sendInfo.id = null;
                that.sendInfo.userName = null;
                that.sendInfo.realName = null;
                that.sendInfo.customerManager = null;
                if (that.getSelect == '1') { //id
                    that.sendInfo.id = that.getValue;
                } else if (that.getSelect == '2') { //账号
                    that.sendInfo.userName = that.getValue;
                } else if (that.getSelect == '3') { //姓名
                    that.sendInfo.realName = that.getValue;
                } else if (that.getSelect == '4') {
                    that.sendInfo.customerManager = that.getValue;
                } else if (that.getSelect == '5') {
                    that.sendInfo.companyName = that.getValue;
                }
                that.$axiosz.get('backstage/sysUser/manage', {params: that.sendInfo}).then((r) => {
                    that.loading = false
                    if (r.code == 200) {
                        that.tableData = r.data.content;
                        that.totalPage = r.data.totalElements;
                    } else {
                        that.$alert(r.msg)
                    }
                }).catch(e=>{
                  that.loading = false
                })
            },
            onOenExpert(){
              this.dialogExpVisible = true
              this.active = 1
              this.exType = 1
              this.downType = void 0
            },
    /**
     * @param {file} 需要上传的文件
     * @description 上传请求方法
     */
    handleUpload(file) {
      // todu 上传请求接口处理
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      that.$api.upload.uploadFile(formData, { uid: file.uid, type: 'ZSKFJ' }).then(q => {
        const { uid, file } = q
        const param = { ...file }
        that.editForm.knowledgeEnclosureIds.push(file.id)
        param.name = file.fileName
        param.uid = uid
        param.url = that.baseUrl + file.filePath
        that.fileItems.push(param)
        that.$message.success('上传成功')
        that.$refs.uploadFile.$data.uploadLoading = false
      }).catch(e => {
        that.$message.info('上传失败')
        const uid = file.uid // 关键作用代码，去除文件列表失败文件
        const currentFile = that.$refs.uploadFile.$children[0]
        const idx = currentFile.uploadFiles.findIndex(item => item.uid === uid) // 关作用代码，去除文件列表失败文件（uploadFiles为el-upload中的ref值）
        console.log(idx, '=======', currentFile.uploadFiles)
        currentFile.uploadFiles.splice(idx, 1)
        that.$refs.uploadFile.$data.uploadLoading = false
      })
    },
    /**
     * @param {index} 需要删除文件对应的下标
     * @description 删除下标对应文件
     */
    async handelRemoveFile(index, file, fileList) {
      // 删除 todu
      const that = this
      const { id } = file
      const fileId = id || that.fileItems[index].id
      await that.$api.upload.delFile(fileId)
      that.$message.success('删除成功')
      that.editForm.knowledgeEnclosureIds.splice(index, 1)
      that.fileItems.splice(index, 1)
    },
    /** 导入模板下载*/
    onDown() {
      if(this.exType === 1){
         const fileName = `${this.downName}.xlsx`
         downLoadTemplate(`/backstage/downloadUserTemplate/${this.downType}`,null,fileName)
      }
      else  this.uploadFile(this.file)
      
      this.innerVisible = false
      
    },
    openInner(){
      this.exType = 1
      this.downType = void 0
      this.innerVisible = true
    },
    /** 提交方法 */
    async onSub() {
      const that = this
      try {

        that.onExport()
        const {code,msg} = await that.$axioszBodys.post(`/backstage/importUserBatch`,that.uploadData.passUserList)
        if(code === 200){
          that.$message.success('导入成功')
          if (that.active === 3) {
            that.percent = 100
            that.active++
            that.stop()
          }
        
        }else{
          that.stop()
          that.$message.info(msg ||'导入失败')
        }
      } catch (e) {
        that.stop()
        console.log('导入异常', e)
        that.$message.info('导入异常')
      }
    },
    /**
     * @param [param,type] 当前行数据，以及操作类型
     * @description 表格操作 新增、审核、编辑等
     */
    handleOperate(params) {
      const that = this
      const [param, type] = params
      that.$nextTick(() => {
        switch (param) {
          case 1:
            that.active++
            if (type) that.onSub()
            break
          case 2:
            that.errorList.active = true
            break
          case 'prev':
            that.active--
            break
          case 'next':
            // const { passCount, errorCount } = that.uploadData
            that.active++
            break
          case 'upload':
            that.errorList.active = false
            that.active = 1
            break
          default:
            break
        }
      })
    },
    handleCommand(command){
      if(command === 1) {
        this.active++
      }else  this.errorList.active = true
    },
    onExport() {
      const that = this
      that.interval = setInterval(function() {
        if (that.percent >= 0 && that.percent < 100) {
          that.percent++
        } else {
          that.active++
          that.stop()
        }
      }, 1000)
    },
    /** 关闭计时器*/
    stop() {
      if (this.interval)window.clearInterval(this.interval)
    },
    onUpload(){
       this.exType = 2
       this.innerVisible = true
    },
    uploadSectionFile(params) {
      var that = this
      this.innerVisible = false
      that.file = params.file
     
      that.uploadFile(that.file)
    },
    async uploadFile(file) {
      var that = this
      var formData = new window.FormData()
      try {
        formData.append('file', file)
        const res = await that.$axiosz.post(`/backstage/importUserVerify?type=${that.downType}`,formData)
        if(res.code === 200){
          that.$nextTick(()=>{
            that.uploadData = res.data
            if(res.data && res.data.errorCount  && res.data.errorCount > 0) {
              that.errorList.active = true
               that.uploading = false
               that.$message.info(`上传数据种异常数量有${ res.data.errorCount || 0}条`)
              that.$refs.upload.uploadFiles = []
              return
            }
            else that.errorList.active = false
            that.uploading = false
            that.$message.success('上传成功')
            that.$refs.upload.uploadFiles = []
          })
        
        }else{
          that.$message.success('上传失败')
        }
      } catch (e) {
        that.uploading = false
        const currentFile = this.$refs.upload
        currentFile.$children[0].clearFiles()
        that.$message.success('上传失败')
      }
    },
    handleUploadError() {
      this.uploading = false
    },
    handleBeforeUpload(file) {
      if (!this.checkSize(file)) {
        this.uploadLoading = false
        return false
      }
      this.uploading = true
    },
    /**
     * @param {file} 文件
     * @description 校验上传的文件大小
     * @author tan 2022/3/14
     */
    checkSize(file) {
      const isLt = file.size / 1024 / 1024 < 10
      if (!isLt) {
        this.$message.error(`上传文件大小不能超过 10M!`)
        return false
      } else return true
    },
    handleUploadSuccess(response, file, fileList) {
      this.uploading = false
    },
    getEums(val, type) {
      const list = this[type].filter(item => item.dictValue === val)
      return list && list.length !== 0 ? list[0].dictName : val
    }
        }
    }
</script>
<style scoped="scoped" lang="scss">
    .forms {
        .child {          
            .remark {
                /deep/ .el-textarea__inner {
                    min-height: 122px !important;
                }
            }
            .name {
                width: 123px;
                text-align: right;
            }
            .content{
              .el-input{
                max-width:400px !important;
              }
            }
        }
        .hint{
          margin-top:40px !important
        }
    }
    .left{
      .child{
        margin-top:0 !important;
      }
    }
.detail{
   padding:20px;
  .step{
    &_title{
      font-size: 14px;
      font-weight: 600;
      color:#666;
    }
    &_desc{
      font-size: 12px;
      color:#999;
      margin-top:5px;
    }
    &_tip{
      width:100%;
      height: 78px;
      background: rgba(255, 245, 230, 1);
      border: 1px solid rgba(255, 235, 204, 1);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:20px;
      margin-top:20px;
      &_title{
        font-size: 14px;
        color:#666;
      }
    }
    &_error{
      &_title{
        font-size: 13px;
        font-weight: 700;
        color: #666;
        span{
          color: #19BE6B;
          font-weight: 400;
        }
        .red{
          color: red;
        }
      }
      &_lists{
        border:1px solid #ccc;
        background: rgba(249, 249, 249, 1);
        padding:20px;
        &_title{
          font-size: 14px;
          font-weight: 700;
          line-height: 24px;
        }
        &_item{
          font-size: 12px;
          line-height: 20px;
          margin-top:10px;
        }
      }
    }
  }
  .step_success{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      justify-content:center;
      min-height:300px;
      .el-icon-success{
        font-size: 48px;
        color:#67c23a;
      }
      &_title{
        font-size: 16px;
        margin-top:20px;
        font-weight: bold;
      }
      &_info{
        margin-top:10px;
        font-size: 14px;
      }
  }
  .step_percentage{
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-progress{
      width:100%;
    }
    &::v-deep{
      .el-progress__text{
        position:absolute;
        top:-25px;
        left:48%;
      }
    }
    &_tip{
      margin-top:20px;
      text-align: center;
      color:#888;
    }
  }
}
::v-deep{
  .el-tab-pane{
    .el-button{
      width:10%;
      margin-bottom:5px;
    }
    .el-button+.el-button{
      margin-left:0;
    }
  }
  .el-icon-dot{
  width:15px;
  height: 15px;
  border-radius: 50%;
  background: #ccc;
}
.is-finish{
  .el-icon-dot{
    background:$primary;
  }
}
.el-step__icon.is-icon{
  width:15px;
}
.el-step__title{
  font-size: 12px;
}
.el-descriptions-item__label{
  vertical-align:middle;
  text-align: center !important;
  width:10% !important;
}

}
.super_radio{
  display: block;
  width:80%;
  margin:0 auto;
  .el-radio{
    width:120px;
    margin-bottom:10px;
  }
  .el-radio:nth-child(3n){
    margin-right: 0 !important;
  }
}
</style>
